import { render } from "./SidebarMenuItem.vue?vue&type=template&id=369dc201&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js"

import "./SidebarMenuItem.vue?vue&type=style&index=0&id=369dc201&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369dc201"]])

export default __exports__